"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TITLE = exports.READ_MORE = exports.MESSAGE = exports.FEEDBACK_BENEFIT_BANNER = void 0;
const FEEDBACK_BENEFIT_BANNER = exports.FEEDBACK_BENEFIT_BANNER = 'feedback-benefit-banner';
const READ_MORE = exports.READ_MORE = 'read-more';
const TITLE = exports.TITLE = 'title';
const MESSAGE = exports.MESSAGE = 'message';
